import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import urlBuilder from '../../../utils/urlBuilder';
import translationPropType from '../../../proptypes/translationPropType';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(1),
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
});

const OrderSystemButton = ({ classes, translation, orderId }) => (
    <Button
        variant="contained"
        color="primary"
        component="a"
        href={urlBuilder.getOrderUrl(orderId)}
        target="_blank"
        className={classes.button}
    >
        <InsertDriveFile className={classes.leftIcon} />
        {translation.OPEN_IN_ORDER_SYSTEM}
    </Button>
);

OrderSystemButton.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: translationPropType.isRequired,
    orderId: PropTypes.string.isRequired,
};

export default withStyles(styles)(OrderSystemButton);
